module.exports = __webpack_public_path__ + "img/pantalla-6-1.b61b00fd.png";